import React, { useState } from "react";
import { useLoadScript, GoogleMap, Marker, Circle } from "@react-google-maps/api";
import "./clock.css";

const mapContainerStyle = { width: "100%", height: "300px" };

const ClockPanel = ({ clock, techLocation, t }) => {
  const {
    isClockedIn,
    handleClockToggle,
    handleLunchToggle,
    mapLocation,
    assignedSite,
    gpsAccuracy,
    isOnline,
    getETA,
    isInsideGeofence,
    getGeofenceStatus,
    geofenceEnabled,
    locationError,
    locationPermission,
    isLocating,
    lastSentAt,
    pendingOfflinePoints,
    refreshLocation,
  } = clock;
  const tr = (key, fallback) => {
    const v = t ? t(key) : key;
    return v && v !== key ? v : fallback;
  };
  const [showPastLogs, setShowPastLogs] = useState(false);
 

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  });

  const geo = getGeofenceStatus ? getGeofenceStatus() : null;

  return (
    <div className="clock-panel">
      {/* Status Row */}
      <div className="status-row">
        <div className={`status-chip ${isOnline ? "online" : "offline"}`}>
        {isOnline ? t("online") : t("offline")}
        </div>

        {gpsAccuracy != null && (
          <div className="status-chip">
            {t("accuracy")}: {Math.round(gpsAccuracy)}m
          </div>
        )}

        {isClockedIn && (
          <div className="status-chip sharing">
            {tr("locationSharing", "Location sharing on")}
            {lastSentAt ? ` · ${lastSentAt.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" })}` : ""}
          </div>
        )}

        {pendingOfflinePoints > 0 && (
          <div className="status-chip offline">
            {pendingOfflinePoints} {tr("pointsWaiting", "points waiting to upload")}
          </div>
        )}
      </div>

      {(locationError || locationPermission === "denied") && (
        <div className="location-alert">
          <div>
            {locationError ||
              "Location is blocked for this app. Turn on Location for this website in your phone/browser settings."}
          </div>
          <button
            className="clock-btn secondary"
            onClick={refreshLocation}
            disabled={isLocating}
          >
            {isLocating ? tr("locating", "Locating…") : tr("retryLocation", "Retry Location")}
          </button>
        </div>
      )}

      {assignedSite && (
        <div className={`geofence-banner ${geo ? (geo.inside ? "inside" : "outside") : ""}`}>
          <strong>{assignedSite.name}</strong>
          {geofenceEnabled
            ? ` — ${tr("geofenceRequired", "clock-in only allowed on site")}`
            : ""}
          {geo && (
            <span>
              {" · "}
              {geo.inside ? tr("onSite", "On site") : tr("offSite", "Off site")}
              {` (${geo.distanceMeters}m)`}
            </span>
          )}
        </div>
      )}


      {/* Buttons */}
<div className="clock-buttons">
  <button
    className={`clock-btn ${isClockedIn ? "danger" : "primary"}`}
    onClick={handleClockToggle}
    disabled={isLocating}
  >
    {isClockedIn ? t("clockOut") : t("clockIn")}
  </button>

  <button
    className={`clock-btn ${isClockedIn ? "warning" : "secondary"}`}
    onClick={handleLunchToggle}
  >
    {isClockedIn ? t("lunchOff") : t("lunchOn")}
  </button>
</div>

{/* ⏱ Period Summary */}
{clock.stats && (
  <div style={{ marginTop: 10, fontSize: "0.95rem" }}>
    <div>
    <strong>
  {clock.stats.firstIsCurrent
    ? t("currentPeriod")
    : t("lastPeriod")}
</strong>
{" "}
      — 1st–14th ({clock.stats.firstHalfPayMonth} 25th Pay Day)
      <br />
      {t("days")}: {clock.stats.firstHalfDays}
      &nbsp;|&nbsp;
      {t("hoursNoLunch")}: {clock.stats.firstHalfHours}
      &nbsp;|&nbsp;
      {t("hoursLunch")}: {clock.stats.firstHalfLunchHours}

    </div>

    <div style={{ marginTop: 6 }}>
      <strong>
        {clock.stats.secondIsCurrent ? t("currentPeriod") : t("lastPeriod")}
      </strong>{" "}
      — 15th–end ({clock.stats.secondHalfPayMonth} 10th Pay Day)
      <br />
      {t("days")}: {clock.stats.secondHalfDays} &nbsp;|&nbsp;
      {t("hoursNoLunch")}: {clock.stats.secondHalfHours}
      &nbsp;|&nbsp;
      {t("hoursLunch")}: {clock.stats.secondHalfLunchHours}

    </div>
  </div>
)}

      {/* Map */}
      {!isLoaded ? (
        <p>Loading map…</p>
      ) : !mapLocation ? (
        <p>{isLocating ? "Fetching location…" : "Location not available yet."}</p>
      ) : (
      <GoogleMap
        mapContainerStyle={mapContainerStyle}
        center={{
          lat: mapLocation.latitude,
          lng: mapLocation.longitude,
        }}
        zoom={16}
      >
        <Marker
          position={{
            lat: mapLocation.latitude,
            lng: mapLocation.longitude,
          }}
          label="You"
        />

        {assignedSite && (
          <>
            <Marker
              position={{
                lat: assignedSite.latitude,
                lng: assignedSite.longitude,
              }}
              label={assignedSite.name}
            />
            {techLocation && (
  <Marker
    position={techLocation}
    icon={{
      url: "/icons/house.png", // or tech icon
      scaledSize: new window.google.maps.Size(32, 32),
    }}
  />
)}

            <Circle
              center={{
                lat: assignedSite.latitude,
                lng: assignedSite.longitude,
              }}
              radius={assignedSite.radiusMeters}
              options={{
                fillColor: isInsideGeofence() ? "#00C851" : "#ff4444",
                fillOpacity: 0.2,
                strokeWeight: 2,
              }}
              
            />
          </>
        )}
      </GoogleMap>
      )}

      {/* ETA */}
      {assignedSite && getETA() && (
        <div style={{ textAlign: "center", marginTop: 8 }}>
          {t("distance")}: {getETA().dist}m · ETA: {getETA().etaMinutes} min
        </div>
      )}
     <div style={{ display: "flex", justifyContent: "center", marginTop: 8 }}>
  <button
    className="clock-btn secondary"
    onClick={() => setShowPastLogs(true)}
  >
    {t("pastLogs")}

  </button>
</div>

{showPastLogs && (
  <div className="past-logs-popup">
    <div className="past-logs-popup-content">
      <button
        className="red-button"
        onClick={() => setShowPastLogs(false)}
      >
        {t("close")}

      </button>

      <h3>{t("pastLogs")}</h3>


      <ul>
      {[...clock.timeLogs]
  .sort((a, b) => {
    const aTime = a.clockIn?.toDate ? a.clockIn.toDate() : a.clockIn;
    const bTime = b.clockIn?.toDate ? b.clockIn.toDate() : b.clockIn;
    return bTime - aTime;
  })
  .filter(
    (log) =>
      !(log.reason || "").toLowerCase().includes("off")
  )
  .map((log) => (
    <li key={log.id}>
  
  <strong>{t("clockIn")}:</strong>
  {" "}
    {(log.clockIn instanceof Date
      ? log.clockIn
      : log.clockIn.toDate()
    ).toLocaleString()}
            {log.clockOut && (
              <>
                <br />
                <strong>{t("clockOut")}:</strong>
{" "}
                {(log.clockOut?.toDate ? log.clockOut.toDate() : new Date(log.clockOut)).toLocaleString()}
                <br />
                <strong>{t("duration")}:</strong>
{" "}
                {log.duration} min
              </>
            )}
          </li>
        ))}
      </ul>
    </div>
  </div>
)}

    </div>
  );
};

export default ClockPanel;
